var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"intersect",rawName:"v-intersect",value:({ true: ['brandhub-paragraph-text--in']}),expression:"{ true: ['brandhub-paragraph-text--in']}"}],class:_vm.rootNodeClasses},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }